export default __webpack_public_path__ + "static/media/sap.1f3a0db3.png";